export default __webpack_public_path__ + "static/media/92.d5b20eb9.jpg";